const HQValuesKey = 'HQSettings';

const getHQSettings = (): Record<string, boolean> => {
  const stringData = sessionStorage.getItem(HQValuesKey);
  if (stringData) {
    return JSON.parse(stringData) as Record<string, boolean>;
  }
  return {};
};
const getHQSetting = (cameraId: string): boolean => {
  const data = getHQSettings();
  if (data && data[cameraId]) {
    return data[cameraId];
  }
  return false;
};

const setHQSetting = (cameraId: string, value: boolean): void => {
  const data = getHQSettings();
  data[cameraId] = value;
  sessionStorage.setItem(HQValuesKey, JSON.stringify(data));
};

export { getHQSettings, getHQSetting, setHQSetting };
